import React from "react";
import editIcon from "../assets/images/icons/edit.svg";
import deleteIcon from "../assets/images/icons/trash.svg";
import downlaodIcon from "../assets/images/icons/download.svg";
import viewIcon from "../assets/images/icons/view.svg";


const ActionButtons = ({ onEdit, onDelete, onDownload, onView, rowData, showDelete, showEdit = true, editBtnIcon = editIcon, additonalBtn = false, viewBtn = false}) => (
  <div className="action-buttons-wrapper">
    {viewBtn && (
      <button
        onClick={() => onView(rowData)}
        title="View"
        className="btn btn-action btn-view"
        aria-label="View application"
      >
        <img 
          src={viewIcon} 
          alt="View" 
          className="action-icon"
        />
        <span className="action-label">View</span>
      </button>
    )}
    {showEdit && (
      <button
        onClick={() => onEdit(rowData)}
        title="Edit"
        className="btn btn-action btn-edit"
        aria-label="Edit application"
      >
        <img 
          src={editBtnIcon} 
          alt="Edit" 
          className="action-icon"
        />
        <span className="action-label">Edit</span>
      </button>
    )}
    { additonalBtn && <button
      onClick={() => onDownload(rowData)}
      title="Download"
      className="btn btn-action btn-download"
      aria-label="Download application"
    >
      <img 
        src={downlaodIcon} 
        alt="Download" 
        className="action-icon"
      />
      <span className="action-label">Download</span>
    </button> }
    {showDelete && <button
      onClick={() => onDelete(rowData)}
      className="btn btn-action btn-delete"
      title="Delete"
      aria-label="Delete application"
    >
      <img 
        src={deleteIcon} 
        alt="Delete" 
        className="action-icon"
      />
      <span className="action-label">Delete</span>
    </button> }
  </div>
);

export default ActionButtons;

